/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index logo to autogenerate all the components and extensions
 * Used by "prepareLogos"
 */

import Logo from './logo/Logo'
export * from './logo/Logo'
export default Logo
